const timelineData = [
    {
      topic: "Hackathon Announcement",
      content:
        "The getlinked tech hackathon 1.0 is formally announced to the general public and teams begin to get ready to register",
      date: "November 18, 2023",
      row: true,
    },
    {
      topic: "Teams Registration begins",
      content:
        "Interested teams can now show their interest in the getlinked tech hackathon 1.0 2023 by proceeding to register",
      date: "November 18, 2023",
      row: false,
    },
    {
      topic: "Teams Registration ends",
      content: "Interested Participants are no longer Allowed to register",
      date: "November 18, 2023",
      row: true,
    },
    {
      topic: "Announcement of the accepted teams and ideas",
      content:
        "All teams whom idea has been accepted into getlinked tech hackathon 1.0 2023 are formally announced",
      date: "November 18, 2023",
      row: false,
    },
    {
      topic: "Getlinked Hackathon 1.0 Offically Begins",
      content:
        "Accepted teams can now proceed to build their ground breaking skill driven solutions",
      date: "November 18, 2023",
      row: true,
    },
    {
      topic: "Demo Day",
      content:
        "Teams get the opportunity to pitch their projects to judges. The winner of the hackathon will also be announced on this day",
      date: "November 18, 2023",
      row: false,
    },
];

    export default timelineData;